import { call, put, takeLatest } from 'redux-saga/effects';
import { httpRequestsOnErrorsActions, httpRequestsOnSuccessActions, httpRequestsOnLoadActions } from 'store';
import { claimService } from './claim.service';
import {
    CLOSE_CLAIM,
    GENERATE_CLAIM,
    GET_CLAIMS,
    GET_CLAIMS_SUCCESS,
    GET_CLAIM_BY_ID,
    GET_CLAIM_BY_ID_SUCCESS,
    SUBMIT_CLAIM,
    GET_BILL_INVOICE_PAYMENT,
    GET_BILL_INVOICE_PAYMENT_SUCCESS,
    GET_BILL_CLAIM_PAYMENT_TRANSACTIONS,
    GET_BILL_CLAIM_PAYMENT_TRANSACTIONS_SUCCESS,
    GET_SUBMITTED_CLAIMS,
    GET_SUBMITTED_CLAIMS_SUCCESS,
    GET_CLAIM_BATCHES,
    GET_CLAIM_BATCHES_SUCCESS,
    GET_CLAIM_BATCH_BY_ID,
    GET_CLAIM_BATCH_BY_ID_SUCCESS,
    SUBMIT_CLAIM_BY_ID,
    REFRESH_CLAIM,
    RESUBMIT_CLAIM,
    EDIT_CLAIM,
    REMOVE_APPT_FROM_CLAIM,
    REFRESH_CLAIM_SUCCESS,
    DELETE_CLAIM,
    GET_BILLING_OVERVIEW,
    GET_BILLING_OVERVIEW_SUCCESS,
    GET_CLAIM_AGING,
    GET_CLAIM_AGING_SUCCESS,
    RE_SUBMIT_CLAIM,
    GET_PENDING_CLAIMS_TOTAL,
    GET_PENDING_CLAIMS_TOTAL_SUCCESS,
    GET_BILLABLE_CLAIMS_TOTAL,
    GET_BILLABLE_CLAIMS_TOTAL_SUCCESS,
    CHANGE_CLAIM_STATUS,
    GET_COMPLETE_CLAIM_TOTALS,
    GET_COMPLETE_CLAIM_TOTALS_SUCCESS,
    APPEAL_SUBMITTED_CLAIM,
    MARK_AS_SECONDARY_BILLING,
    CANCEL_CLAIM,
    MARK_AS_READY_SECONDARY_BILLING,
    EDIT_READY_SECONDARY_BILLING,
    REFRESH_APPT_UNITS,
    CHECK_CLAIM_STATUS,
    UPDATE_BILL_ADJUSTMENTS,
} from './claim.type';
import { claimPaymentService } from '../../posting/claimPayment/claimPayment.service';
import { toast } from 'react-toastify';
import { NotError } from '../../../components';
import React from 'react';

function* getClaims(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(claimService.getClaimsService, action?.payload?.data);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_CLAIMS_SUCCESS,
            payload: { claims: res.data },
        });
    } catch (err) {
        yield put({
            type: GET_CLAIMS_SUCCESS,
            payload: { claims: [] },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* getPendingClaimsTotal(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(claimService.getPendingClaimsTotalService, action?.payload?.data);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_PENDING_CLAIMS_TOTAL_SUCCESS,
            payload: res?.data,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getBillableClaimsTotal(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(claimService.getBillableClaimsTotalService, action?.payload?.data);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_BILLABLE_CLAIMS_TOTAL_SUCCESS,
            payload: res?.data,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getClaimAging(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(claimService.getClaimAgingService, action?.payload?.data);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_CLAIM_AGING_SUCCESS,
            payload: res.data ,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getCompletedClaimTotals(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const res = yield call(claimService.getCompletedClaimTotalsService, action?.payload?.data);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_COMPLETE_CLAIM_TOTALS_SUCCESS,
            payload: res.data,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* getSubmittedClaims(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(claimService.getSubmittedClaimsService, action?.payload?.data);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));

        yield put({
            type: GET_SUBMITTED_CLAIMS_SUCCESS,
            payload: res?.data,
        });
    } catch (err) {
        yield put({
            type: GET_SUBMITTED_CLAIMS_SUCCESS,
            payload: { claims: [] },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* getClaimBatches(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(claimService.getClaimBatchesService, action?.payload?.data);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_CLAIM_BATCHES_SUCCESS,
            payload: res?.data,
        });
    } catch (err) {
        yield put({
            type: GET_CLAIM_BATCHES_SUCCESS,
            payload: { claimBatches: [], count: 0 },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* getClaimBatchById(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(claimService.getClaimBatchByIdService, action?.payload?.id);
        const data = res?.data;
        // `/claim/batch/:id` populates raw claim docs, so `displayId` arrives as the
        // full DisplayId object ({fullId, prefix, suffix, month}) rather than the
        // `fullId` string the submitted-claims table renders. Normalize it here so the
        // shared claim table (and OpenClaimDetails, which renders displayId directly)
        // receives the same string shape as the regular submitted-claims endpoint.
        const normalized = Array.isArray(data?.claims)
            ? {
                  ...data,
                  claims: data.claims.map((claim) => ({
                      ...claim,
                      displayId: claim?.displayId?.fullId ?? claim?.displayId,
                  })),
              }
            : data;
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_CLAIM_BATCH_BY_ID_SUCCESS,
            payload: normalized,
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* getClaimById(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    if (action.payload.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(claimService.getClaimByIdService, action?.payload?.id);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_CLAIM_BY_ID_SUCCESS,
            payload: { claimById: res.data },
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        if (err?.data?.message === 'Internal server error') {
            yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        }
    }
}

function* generateClaim(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(claimService.generateClaimService, action?.payload?.body, action?.payload?.params);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* editClaim(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(claimService.editClaimService, action?.payload?.id, action?.payload?.body);
        const res = yield call(claimService.getClaimByIdService, action?.payload?.id);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put({
            type: GET_CLAIM_BY_ID_SUCCESS,
            payload: { claimById: res.data },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* deleteClaim(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(claimService.deleteClaimService, action?.payload?.params);
        // const res = yield call(claimService.getClaimByIdService, action?.payload?.id);
        // yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        // yield put({
        //     type: GET_CLAIM_BY_ID_SUCCESS,
        //     payload: { claimById: res.data },
        // });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* changeClaimStatus(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(claimService.changeClaimStatusService, action?.payload?.params);

        if (action?.payload?.singleId) {
            const res = yield call(claimService.getClaimByIdService, action?.payload?.singleId);
            yield put({
                type: GET_CLAIM_BY_ID_SUCCESS,
                payload: { claimById: res.data },
            });
        }
        // const res = yield call(claimService.getClaimByIdService, action?.payload?.id);
        // yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        // yield put({
        //     type: GET_CLAIM_BY_ID_SUCCESS,
        //     payload: { claimById: res.data },
        // });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* appealSubmittedClaim(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(claimPaymentService.appealClaimPmtService, action?.payload?.params);

        if (action?.payload?.claimId) {
            const res = yield call(claimService.getClaimByIdService, action?.payload?.claimId);
            yield put({
                type: GET_CLAIM_BY_ID_SUCCESS,
                payload: { claimById: res.data },
            });
        } else {
            const res = yield call(claimService.getClaimsService, action?.payload?.renderParams);
            yield put(httpRequestsOnLoadActions.removeLoading(action.type));
            yield put({
                type: GET_CLAIMS_SUCCESS,
                payload: { claims: res.data },
            });
        }

        // yield call(claimService.changeClaimStatusService, action?.payload?.params);
        //
        // if (action?.payload?.singleId) {
        //     const res = yield call(claimService.getClaimByIdService, action?.payload?.singleId);
        //     yield put({
        //         type: GET_CLAIM_BY_ID_SUCCESS,
        //         payload: { claimById: res.data },
        //     });
        // }
        // const res = yield call(claimService.getClaimByIdService, action?.payload?.id);
        // yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        // yield put({
        //     type: GET_CLAIM_BY_ID_SUCCESS,
        //     payload: { claimById: res.data },
        // });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/**Claim Status Actions */
function* closeClaim(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(claimService.closeClaimService, action.payload.id, action.payload.details);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put({
            type: GET_CLAIM_BY_ID,
            payload: { id: action.payload.id },
        });
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* checkClaimStatus(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const statusRes = yield call(claimService.checkClaimStatusService, action.payload.params);
        const statusData = statusRes?.data;

        if (action?.payload?.claimId) {
            const res = yield call(claimService.getClaimByIdService, action?.payload?.claimId);
            yield put({
                type: GET_CLAIM_BY_ID_SUCCESS,
                payload: { claimById: res.data },
            });
        }

        yield put(httpRequestsOnLoadActions.removeLoading(action.type));

        // Surface per-claim errors from the response (API returns 200 with errors in results)
        const errorResults = (statusData?.results || []).filter((r) => r.error);
        const successResults = (statusData?.results || []).filter((r) => !r.error);

        if (errorResults.length > 0) {
            const errMsg = errorResults.map((r) => `${r.displayId}: ${r.error}`).join('\n');
            yield put(httpRequestsOnErrorsActions.appendError(action.type, errMsg));
            toast(
                <NotError
                    type={'error'}
                    errMessage={errorResults.map((r) => (
                        <span key={r.claimId} style={{ display: 'block' }}>
                            <b>{r.displayId}</b>: {r.error}
                        </span>
                    ))}
                />
            );
        }

        if (successResults.length > 0) {
            toast(
                <NotError
                    type={'success'}
                    errMessage={successResults.map((r) => (
                        <span key={r.claimId} style={{ display: 'block', marginBottom: 4 }}>
                            <b>{r.displayId}</b>: {r.statusChanged
                                ? `${r.previousStatus} → ${r.newStatus}`
                                : r.statusCodeValue || r.statusCategoryCodeValue || `Status: ${r.newStatus}`}
                        </span>
                    ))}
                />
            );
        }

        // Always fire success so afterSuccess callbacks run (e.g., list refresh).
        // Some claims may have updated even when others errored.
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
    }
}

function* cancelClaim(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(claimService.cancelClaimService, action.payload.params);

        if (action?.payload?.claimId) {
            const res = yield call(claimService.getClaimByIdService, action?.payload?.claimId);
            yield put({
                type: GET_CLAIM_BY_ID_SUCCESS,
                payload: { claimById: res.data },
            });
        }
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* submitClaim(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        if (action?.payload?.type) {
            yield call(claimService.submitClaimClearinghouseService, action?.payload?.id, action?.payload?.type);
        } else {
            yield call(claimService.submitClaimService, action?.payload?.id);
        }

        yield put(httpRequestsOnLoadActions.removeLoading(action.type));

        if (action?.payload?.type === 'officeAlly') {
            yield put(httpRequestsOnSuccessActions.appendSuccess('SUBMIT_CLAIM_OFFICE_ALLY'));
        }
        if (action?.payload?.type === 'manual') {
            yield put(httpRequestsOnSuccessActions.appendSuccess('SUBMIT_CLAIM_MANUAL'));
        }

        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* reSubmitClaim(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(claimService.reSubmitClaimService, action?.payload?.ids);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* submitClaimById(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(claimService.submitClaimService, action?.payload?.id);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));

        yield put({
            type: GET_CLAIM_BY_ID,
            payload: { id: action?.payload?.id, load: 'noLoad' },
        });
    } catch (err) {
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* refreshClaim(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        const res = yield call(claimService.refreshClaimService, action?.payload?.id);
        yield put({
            type: REFRESH_CLAIM_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (e) {
        let errorData = e?.data;
        if (errorData instanceof ArrayBuffer) {
            try {
                const text = new TextDecoder().decode(errorData);
                errorData = JSON.parse(text);
            } catch (_) {}
        }
        toast(<NotError type={'error'} errMessage={errorData?.message} />);
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* resubmitClaim(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        yield call(claimService.resubmitClaimService, action?.payload?.id);
        const res = yield call(claimService.getClaimByIdService, action?.payload?.id);
        yield put({
            type: GET_CLAIM_BY_ID_SUCCESS,
            payload: { claimById: res.data },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* removeFromClaim(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    try {
        if (action?.payload?.status === 'PENDING') {
            yield call(claimService.removePendingFromClaimService, action?.payload?.data);
        } else {
            yield call(claimService.removeFromClaimService, action?.payload?.data);
        }

        const res = yield call(claimService.getClaimByIdService, action?.payload?.claimId);
        yield put({
            type: GET_CLAIM_BY_ID_SUCCESS,
            payload: { claimById: res.data },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

/** End */
function* billClaimPmtTr(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const res = yield call(claimService.billClaimPmtService, action.payload.id);
        yield put({
            type: GET_BILL_CLAIM_PAYMENT_TRANSACTIONS_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

function* billInvoicePmt(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        const res = yield call(claimService.billInvoicePmtService, action?.payload?.ids);
        yield put({
            type: GET_BILL_INVOICE_PAYMENT_SUCCESS,
            payload: res?.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    }
}

/** Overview */

function* getBillingOverview(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(claimService.getBillingOverviewService, action?.payload?.params);
        yield put({
            type: GET_BILLING_OVERVIEW_SUCCESS,
            payload: res.data,
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

/** End */

function* markAsSecondaryBilling(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        const res = yield call(claimService.markAsSecondaryBillingService, action?.payload?.claimId, action?.payload?.params);

        if (res?.data?.message === 'Cannot mark claim for secondary billing as it has an associated invoice.') {
            // toast(<NotError type={'error'} errMessage={res?.data?.message} />);
            yield put(httpRequestsOnErrorsActions.appendError(action.type, res?.data));
        } else {
            // yield put({
            //     type: GET_BILLING_OVERVIEW_SUCCESS,
            //     payload: res.data,
            // });
            yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        }
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* markAsReadySecondaryBilling(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    if (action?.payload?.load !== 'noLoad') {
        yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    }
    try {
        yield call(claimService.markAsReadySecondaryBillingService, action?.payload?.claimId, action?.payload?.body);

        const res = yield call(claimService.getClaimByIdService, action?.payload?.claimId);
        yield put({
            type: GET_CLAIM_BY_ID_SUCCESS,
            payload: { claimById: res.data },
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}
function* editReadySecondaryBilling(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        yield call(claimService.markAsReadySecondaryBillingService, action?.payload?.claimId, action?.payload?.body);
        const res = yield call(claimService.getClaimByIdService, action?.payload?.claimId);
        yield put({
            type: GET_CLAIM_BY_ID_SUCCESS,
            payload: { claimById: res.data },
        });

        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* refreshApptUnits(action) {
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    try {
        yield call(claimService.refreshApptUnitsService, action?.payload?.apptId);
        const res = yield call(claimService.getClaimByIdService, action?.payload?.claimId);
        yield put({
            type: GET_CLAIM_BY_ID_SUCCESS,
            payload: { claimById: res.data },
        });
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

function* updateBillAdjustments(action) {
    yield put(httpRequestsOnErrorsActions.removeError(action.type));
    yield put(httpRequestsOnSuccessActions.removeSuccess(action.type));
    yield put(httpRequestsOnLoadActions.appendLoading(action.type));
    try {
        yield call(
            claimService.updateBillAdjustmentsService,
            action?.payload?.claimId,
            action?.payload?.billId,
            action?.payload?.adjustments
        );
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnSuccessActions.appendSuccess(action.type));
    } catch (err) {
        toast(<NotError type={'error'} errMessage={err?.data?.message} />);
        yield put(httpRequestsOnLoadActions.removeLoading(action.type));
        yield put(httpRequestsOnErrorsActions.appendError(action.type, err?.data?.message));
    }
}

export const watchClaim = function* watchClaimSaga() {
    yield takeLatest(GET_CLAIMS, getClaims);
    yield takeLatest(GET_PENDING_CLAIMS_TOTAL, getPendingClaimsTotal);
    yield takeLatest(GET_BILLABLE_CLAIMS_TOTAL, getBillableClaimsTotal);
    yield takeLatest(GET_CLAIM_AGING, getClaimAging);
    yield takeLatest(GET_COMPLETE_CLAIM_TOTALS, getCompletedClaimTotals);
    yield takeLatest(GET_SUBMITTED_CLAIMS, getSubmittedClaims);
    yield takeLatest(GET_CLAIM_BATCHES, getClaimBatches);
    yield takeLatest(GET_CLAIM_BATCH_BY_ID, getClaimBatchById);
    yield takeLatest(GET_CLAIM_BY_ID, getClaimById);
    yield takeLatest(GENERATE_CLAIM, generateClaim);
    yield takeLatest(EDIT_CLAIM, editClaim);
    yield takeLatest(DELETE_CLAIM, deleteClaim);
    yield takeLatest(CHANGE_CLAIM_STATUS, changeClaimStatus);
    yield takeLatest(APPEAL_SUBMITTED_CLAIM, appealSubmittedClaim);
    /**Claim Status Actions */
    yield takeLatest(CHECK_CLAIM_STATUS, checkClaimStatus);
    yield takeLatest(CANCEL_CLAIM, cancelClaim);
    yield takeLatest(CLOSE_CLAIM, closeClaim);
    yield takeLatest(SUBMIT_CLAIM, submitClaim);
    yield takeLatest(RE_SUBMIT_CLAIM, reSubmitClaim);
    yield takeLatest(SUBMIT_CLAIM_BY_ID, submitClaimById);
    yield takeLatest(REFRESH_CLAIM, refreshClaim);
    yield takeLatest(RESUBMIT_CLAIM, resubmitClaim);
    yield takeLatest(REMOVE_APPT_FROM_CLAIM, removeFromClaim);
    /**Bill Details */
    yield takeLatest(GET_BILL_CLAIM_PAYMENT_TRANSACTIONS, billClaimPmtTr);
    yield takeLatest(GET_BILL_INVOICE_PAYMENT, billInvoicePmt);

    /** Overview */
    yield takeLatest(GET_BILLING_OVERVIEW, getBillingOverview);
    /** End */

    yield takeLatest(MARK_AS_SECONDARY_BILLING, markAsSecondaryBilling);
    yield takeLatest(MARK_AS_READY_SECONDARY_BILLING, markAsReadySecondaryBilling);
    yield takeLatest(EDIT_READY_SECONDARY_BILLING, editReadySecondaryBilling);
    yield takeLatest(REFRESH_APPT_UNITS, refreshApptUnits);
    yield takeLatest(UPDATE_BILL_ADJUSTMENTS, updateBillAdjustments);
};
